// src/components/WordCountTextFieldWithExample.js
import React from "react";
import { Box } from "@mui/material";

import WordCountTextField from "./WordCountTextField";
import TextFieldGuides from "./WordCountTextField/TextFieldGuides";

import LightbulbOutlinedIcon from "@mui/icons-material/LightbulbOutlined";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";

/**
 * WordCountTextFieldWithExample
 *
 * Responsibility:
 *  - Compose:
 *      - WordCountTextField (field + progress bar)
 *      - TextFieldGuides (Example + Guiding questions, etc.)
 *
 * Props:
 *  - All WordCountTextField props (label, value, onChange, minWords, maxWords, ...)
 *  - exampleText?: string
 *  - exampleTitle?: string
 *  - guidingText?: string
 *  - guidingTitle?: string
 *  - rightAction?: ReactNode (optional button on the right)
 */
export default function WordCountTextFieldWithExample({
  exampleText,
  exampleTitle = "Example",
  guidingText,
  guidingTitle = "Guiding questions",
  rightAction,
  ...textFieldProps
}) {
  const guides = [];

  if (guidingText && guidingText.trim().length > 0) {
    guides.push({
      id: "guiding",
      title: guidingTitle,
      content: guidingText,
      buttonLabelCollapsed: "Show guiding questions",
      buttonLabelExpanded: "Hide guiding questions",
      icon: <HelpOutlineOutlinedIcon fontSize="small" />,
      defaultOpen: false,
    });
  }

  if (exampleText && exampleText.trim().length > 0) {
    guides.push({
      id: "example",
      title: exampleTitle,
      content: exampleText,
      buttonLabelCollapsed: "Show example",
      buttonLabelExpanded: "Hide example",
      icon: <LightbulbOutlinedIcon fontSize="small" />,
      defaultOpen: false,
    });
  }

  return (
    <Box>
      <Box sx={{ mb: 2 }}>
        <TextFieldGuides guides={guides} rightAction={rightAction} />
      </Box>
      <WordCountTextField {...textFieldProps} />
    </Box>
  );
}
